import React from 'react'
import { inject, observer } from 'mobx-react'
import { flow } from 'lodash'
import i18next from 'i18next'

import PasswordResetsApi from '../../api/PasswordResetsApi'
import { history } from '../browserHistory'
import UsePasswordResetForm from './UseForm'

const UsePasswordResetPage = ({ match, showAlert }) => {
  const token = match.params.token

  const usePasswordReset = (values) => {
    const data = { ...values, locale: i18next.language }
    return PasswordResetsApi.usePasswordReset(token, data).then(({ json }) => {
      if (json.error) {
        showAlert(json.error)
      } else if (json.errors) {
        showAlert(Object.values(json.errors).join(', '))
      } else {
        history.push({ pathname: '/', state: { forward: true } })
        showAlert(i18next.t('auth.resetPasswordSuccess'))
      }
    })
  }

  return <UsePasswordResetForm usePasswordReset={usePasswordReset} />
}

export default flow(
  observer,
  inject(({ mst: { alertMessages } }) => ({
    showAlert: (msg) => alertMessages.showAlert(msg)
  }))
)(UsePasswordResetPage)
